function voComponents () {
    class VoDarkToggle extends HTMLElement {
        connectedCallback () {
            this.darkMode = this.dataset.darkMode;
            this.darkModeToggle = document.querySelector(`[data-dark-mode-toggle="${this.darkMode}"]`);
            this.darkModeToggle?.addEventListener("click", this.toggleDarkMode.bind(this));
        }

        toggleDarkMode () {
            if (this.dataset.darkMode) {
                document.documentElement.classList.toggle(this.dataset.darkMode);
            }
        }
    }

    class VoTabs extends HTMLElement {
        connectedCallback () {
            this.tabList = this.querySelector(`[role="tablist"]`);
            this.tabButtons = this.querySelectorAll(`[role="tab"]`);
            this.tabPanels = this.querySelectorAll(`[role="tabpanel"]`);
            this.underlineEl = this.querySelector("[data-tabs-underline]");

            this.tabButtons.forEach(tb => tb.addEventListener("click", this.tabBtn_clickHandler));

            if (this.tabButtons.length > 0) {
                this.selectTab(this.tabButtons[0]);
            }
        }

        disconnectedCallback () {
            this.tabButtons.forEach(tb => tb.removeEventListener("click", this.tabBtn_clickHandler));
        }

        tabBtn_clickHandler = (event) => {
            this.selectTab(event.currentTarget);
        }

        selectTab (selTab) {
            this.tabButtons.forEach(tb => {
                const isCurrent = tb === selTab;
                tb.ariaSelected = isCurrent;
                tb.toggleAttribute("data-current", isCurrent);

                if (isCurrent) {
                    this.showPanel(tb.getAttribute("data-tabs-target"));
                    this.updateUnderline(tb.offsetLeft, tb.offsetTop + tb.offsetHeight, tb.offsetWidth);
                }
            });
        }

        showPanel (selector) {
            const target = selector ? this.querySelector(selector) : null;

            this.tabPanels.forEach(tp => {
                tp.toggleAttribute("data-current", tp === target);
            });
        }

        updateUnderline (left, top, width) {
            if (this.underlineEl) {
                this.underlineEl.style.left = `${left}px`;
                this.underlineEl.style.top = `${top - this.underlineEl.offsetHeight}px`;
                this.underlineEl.style.width = `${width}px`;
            }
        }
    }

     class VoDialog extends HTMLElement {
        connectedCallback() {
            this.animationClass = this.dataset.animationClass || "";
            this.closeButtons = this.querySelectorAll(".js-vo-modal-close");

            this.closeButtons.forEach(btn => btn.addEventListener("click", this.close));
            window.addEventListener("keydown", this.window_keydownHandler);
        }

        disconnectedCallback() {
            this.closeButtons.forEach(btn => btn.removeEventListener("click", this.close));
            window.removeEventListener("keydown", this.window_keydownHandler);
        }

        window_keydownHandler = (event) => {
            if (event.key?.toLowerCase() === "escape") {
                this.close();
            }
        }

        showModal = () => {
            this.dataset.open = "true";
            this.classList.remove("tw-invisible", "tw-opacity-0");
            if (this.animationClass) this.classList.add(this.animationClass);

            this.dispatchEvent(new CustomEvent("open"));
        }

        open = () => {
            this.dataset.open = "true";
            this.classList.remove("tw-invisible", "tw-opacity-0");
            this.classList.add("tw-animate-slide-left");

            this.dispatchEvent(new CustomEvent("open"));
        }
        close = () => {
            this.dataset.open = "false";
            this.classList.add("tw-invisible", "tw-opacity-0");
            if (this.animationClass) this.classList.remove(this.animationClass);
            this.dispatchEvent(new CustomEvent("close"));
        }

        disconnectedCallback() {
            this.querySelectorAll(".js-vo-modal-close").forEach(btn => btn.removeEventListener("click", this.close));
        }
    }

    class VoModalTrigger extends HTMLElement {
        connectedCallback() {
            this.modal = document.querySelectorAll(`#${this.dataset.modalId}`);
            this.trigger = this.querySelector(".js-modal-trigger") || this.querySelector("button");
            
            this.animation = this.hasAttribute("data-animate");
            this.animateBody = this.dataset.animateBody === "true";
            
            this.trigger?.addEventListener("click", this.triggerClickHandler);

            if (this.animateBody) {
                document.body.classList.add("tw-transition-transform");
                document.body.classList.add("tw-duration-300");
            }
            
            if (this.animation) {
                this.modal.forEach(element => {
                    element?.addEventListener('close', this.modalCloseHandler);
                })
            }
        }

        disconnectedCallback() {
            this.trigger?.removeEventListener("click", this.triggerClickHandler);

            if (this.animateBody) {
                document.body.classList.remove("tw-transition-transform");
                document.body.classList.remove("tw-duration-300");
            }

            if (this.animation) {
                this.modal.forEach(element => {
                    element?.removeEventListener('close', this.modalCloseHandler);
                })
            }
        }

        triggerClickHandler = () => {     
            this.modal.forEach(element => {
                element?.showModal();
            });       

            if (!this.animation) return;

            this.modal.forEach(element => {
                element?.classList.remove("tw-translate-x-full")
            })
            if (this.animateBody) document.body.style.overflowY = "hidden";
        }

        modalCloseHandler = () => {
            this.modal.forEach(element => {
                element?.classList.add("tw-translate-x-full")
            })
            if (this.animateBody) document.body.style.overflowY = "auto";

        }
    }

    class VoModalCloser extends HTMLElement {
        connectedCallback() {
            this.modal = this.closest("dialog");
            this.backdropClickClose = this.dataset.backdropClose === "true";
            
            this.addEventListener("click", this.closeModal);

            if (this.backdropClickClose) {
                this.modal?.addEventListener("click", this.backdropClickHandler);   
            }
        }

        backdropClickHandler = (event) => {
            if (event.target === this.modal) {
                this.closeModal();
            }
        }

        closeModal = () => {
            this.modal?.close();
        }

        disconnectedCallback() {
            this.removeEventListener("click", this.closeModal);
            
            if (this.backdropClickClose) {
                this.modal?.removeEventListener("click", this.backdropClickHandler);
            }
        }
    }

    class VoTextField extends HTMLElement {
        connectedCallback() {
            // Elements
            this.input = this.querySelector('input');
            this.textArea = this.querySelector('textarea');
            this.emptyField = this.querySelector('.js-empty-field');
            this.characterCounter = this.querySelector('.js-character-counter');
            this.dropdownOptions = this.querySelectorAll('.js-dropdown-option');
            this.showPickerBtns = this.querySelectorAll('.js-show-picker');
            this.showPassBtn = this.querySelector('.js-show-pass');

            // Icon wrappers (span) attesi per show/hide password
            this.iconEye = this.showPassBtn?.querySelector('.js-eye');
            this.iconEyeOff = this.showPassBtn?.querySelector('.js-eye-off');

            this.sanitizeShowPassMarkup();

            this.iconEye = this.showPassBtn?.querySelector('.js-eye');
            this.iconEyeOff = this.showPassBtn?.querySelector('.js-eye-off');

            this.input?.addEventListener('input', this.inputHandler);
            this.emptyField?.addEventListener('pointerdown', this.emptyFieldHandler);
            this.showPassBtn?.addEventListener('click', this.showPassBtnHandler);

            if (this.textArea && this.textArea.maxLength > 0) {
                this.textArea.addEventListener('input', this.textAreaHandler);
            }

            this.dropdownOptions.forEach((span) => {
                span.addEventListener('pointerdown', this.dropdownOptionHandler);
            });

            this.showPickerBtns.forEach((btn) => {
                btn.addEventListener('click', this.pickerBtnHandler);
            });

            this.syncPasswordIcons();
            this.inputHandler();
        }

        disconnectedCallback() {
            this.input?.removeEventListener('input', this.inputHandler);
            this.textArea?.removeEventListener('input', this.textAreaHandler);
            this.emptyField?.removeEventListener('pointerdown', this.emptyFieldHandler);
            this.showPassBtn?.removeEventListener('click', this.showPassBtnHandler);

            this.dropdownOptions.forEach((span) => {
                span.removeEventListener('pointerdown', this.dropdownOptionHandler);
            });

            this.showPickerBtns.forEach((btn) => {
                btn.removeEventListener('click', this.pickerBtnHandler);
            });
        }

        sanitizeShowPassMarkup = () => {
            if (!this.showPassBtn) return;

            let eyeWrapper = this.showPassBtn.querySelector('.js-eye');
            let eyeOffWrapper = this.showPassBtn.querySelector('.js-eye-off');

            if (!eyeWrapper) {
                eyeWrapper = document.createElement('span');
                eyeWrapper.className = 'js-eye';
                eyeWrapper.setAttribute('aria-hidden', 'true');
                this.showPassBtn.prepend(eyeWrapper);
            }
            if (!eyeOffWrapper) {
                eyeOffWrapper = document.createElement('span');
                eyeOffWrapper.className = 'js-eye-off tw-hidden';
                eyeOffWrapper.setAttribute('aria-hidden', 'true');
                this.showPassBtn.append(eyeOffWrapper);
            }


            const svgs = Array.from(this.showPassBtn.querySelectorAll('svg'));
            const isInWrapper = (svg) => svg.closest('.js-eye, .js-eye-off') !== null;

            let assignedEye = eyeWrapper.querySelector('svg');
            let assignedEyeOff = eyeOffWrapper.querySelector('svg');

            svgs.forEach((svg) => {
                if (isInWrapper(svg)) return;
                if (!assignedEye) {
                    eyeWrapper.appendChild(svg);
                    assignedEye = svg;
                    return;
                }
                if (!assignedEyeOff) {
                    eyeOffWrapper.appendChild(svg);
                    assignedEyeOff = svg;
                    return;
                }
                svg.remove();
            });


            assignedEye = eyeWrapper.querySelector('svg');
            assignedEyeOff = eyeOffWrapper.querySelector('svg');
            if (!assignedEye && assignedEyeOff) {
                eyeWrapper.appendChild(assignedEyeOff.cloneNode(true));
            } else if (!assignedEyeOff && assignedEye) {
                eyeOffWrapper.appendChild(assignedEye.cloneNode(true));
            }
        };

        inputHandler = () => {
            if (!this.emptyField) return;
            const hasValue = (this.input?.value?.length ?? 0) > 0;
            this.emptyField.classList.toggle('tw-hidden', !hasValue);
        };

        textAreaHandler = () => {
            if (!this.characterCounter || !this.textArea) return;
            this.characterCounter.textContent = this.textArea.value.length;
        };

        emptyFieldHandler = () => {
            if (!this.input) return;
            this.input.value = '';
            this.input.dispatchEvent(new Event('input', { bubbles: true }));
            this.emptyField?.classList.add('tw-hidden');
            this.input.dispatchEvent(new CustomEvent('empty', { bubbles: true }));
            this.syncPasswordIcons();
        };

        dropdownOptionHandler = (event) => {
            const value = event.target?.textContent;
            if (this.input && value != null) {
                this.input.value = value.trim();
                this.input.dispatchEvent(new Event('input', { bubbles: true }));
                this.inputHandler();
            }
        };

        pickerBtnHandler = () => {
            if (this.input && !this.input.disabled && !this.input.readOnly && typeof this.input.showPicker === 'function') {
                this.input.focus();
                this.input.showPicker();
            }
        };

        showPassBtnHandler = () => {
            if (!this.input) return;
            const willShow = this.input.type === 'password';
            this.input.type = willShow ? 'text' : 'password';
            this.syncPasswordIcons();
        };

        syncPasswordIcons = () => {
            const isVisible = this.input?.type === 'text';

            if (this.iconEye && this.iconEyeOff) {
                this.iconEye.classList.toggle('tw-hidden', !isVisible);
                this.iconEyeOff.classList.toggle('tw-hidden', isVisible);
            }

            // A11y sul bottone
            if (this.showPassBtn) {
                this.showPassBtn.setAttribute('aria-pressed', String(isVisible));
                this.showPassBtn.setAttribute('aria-label', isVisible ? 'Nascondi password' : 'Mostra password');
            }
        };
    }

    class VoRangeSlider extends HTMLElement {
        connectedCallback () {
            this.inputMin = this.querySelector("input[data-slider-in='min']");
            this.inputMax = this.querySelector("input[data-slider-in='max']");
            this.track = this.querySelector("[data-slider-track]");
            this.range = this.querySelector("[data-slider-range]");
            this.labels = this.querySelectorAll("[data-slider-lb]");
            this.stepDisplay = this.querySelector("[data-step-display]");

            this.limitMin = Number(this.dataset.min) || 0;
            this.limitMax = Number(this.dataset.max) || 100;
            this.minRange = Number(this.dataset.minRange) || 0;
            this.stepGuides = Number(this.dataset.stepGuides) || 0;
            this.minVal = Number(this.inputMin?.value) || this.limitMin;
            this.maxVal = Number(this.inputMax?.value) || this.limitMax;

            if (this.inputMin) {
                this.inputMin.setAttribute("min", this.limitMin);
                this.inputMin.setAttribute("max", this.limitMax);
                this.inputMin.addEventListener("input", this.minInputHandler);
            }

            if (this.inputMax) {
                this.inputMax.setAttribute("min", this.limitMin);
                this.inputMax.setAttribute("max", this.limitMax);
                this.inputMax.addEventListener("input", this.maxInputHandler);
            }

            this.addEventListener("click", this.clickHandler);
            this.setCurrentAttr("min");
            this.updateStepDisplay();
            this.updateRange();
        }

        disconnectedCallback () {
            this.inputMin?.removeEventListener("input", this.minInputHandler);
            this.inputMax?.removeEventListener("input", this.maxInputHandler);
            this.removeEventListener("click", this.clickHandler);
        }

        clickHandler = (e) => {
            const currSlider = e.target.getAttribute("data-slider-in") || e.target.getAttribute("data-slider-lb");

            if (currSlider) {
                this.setCurrentAttr(currSlider);
            }
        }

        maxInputHandler = (e) => {
            const value = Math.max(Number(e.target.value), this.minVal + this.minRange);
            
            this.maxVal = value;
            e.target.value = value;

            this.setCurrentAttr("max");
            this.updateRange();
        }

        minInputHandler = (e) => {
            const value = Math.min(Number(e.target.value), this.maxVal - this.minRange);
            
            this.minVal = value;
            e.target.value = value;

            this.setCurrentAttr("min");
            this.updateRange();
        }

        getPercent (val) {
            return Math.round(((val - this.limitMin) / (this.limitMax - this.limitMin)) * 100);
        }

        setCurrentAttr (currentSlider) {
            this.inputMin?.toggleAttribute("data-current", currentSlider === "min");
            this.inputMax?.toggleAttribute("data-current", currentSlider === "max");

            this.labels.forEach(lb => {
                lb.toggleAttribute("data-current", lb.getAttribute("data-slider-lb") === currentSlider);
            });
        }

        updateRange () {
            const minPerc = this.getPercent(this.minVal);
            const maxPerc = this.getPercent(this.maxVal);

            if (this.range) {
                this.range.style.left = `${minPerc}%`;
                this.range.style.width = `${maxPerc - minPerc}%`;
            }

            this.labels.forEach(lb => {
                switch (lb.getAttribute("data-slider-lb")) {
                    case "min":
                        lb.style.left = `${minPerc}%`;
                        lb.textContent = this.minVal;
                        break;
                    case "max":
                        lb.style.left = `${maxPerc}%`;
                        lb.textContent = this.maxVal;
                        break;
                }
            });
        }

        updateStepDisplay () {
            const numStep = this.stepGuides;
            let stepHTML = "";

            if (!this.stepDisplay || !numStep) {
                return;
            }

            for (let i = 0; i <= numStep; i++) {
                const primary = i === 0 || i === numStep / 2 || i === numStep;
                stepHTML += `<span data-step-index="${i}" ${primary ? "data-step-primary" : ""}></span>`;
            }
            
            this.stepDisplay.innerHTML = stepHTML;
        }
    }

    class VoQuantitySelector extends HTMLElement {
        connectedCallback() {
            this.input = this.querySelector("input");
            this.quantityAdd = this.querySelector("[data-quantity-add]");
            this.quantitySub = this.querySelector("[data-quantity-sub]");
            this.quantityAdd?.addEventListener("click", this.quantityAddHandler);
            this.quantitySub?.addEventListener("click", this.quantitySubHandler);
        }

        quantityAddHandler = () => {
            this.input.value = Math.max(0, Number(this.input.value) + 1);
        }

        quantitySubHandler = () => {
            this.input.value = Math.max(0, Number(this.input.value) - 1);
        }
    }

    class VoDeliveryEstimator extends HTMLElement {
        connectedCallback () {
            const configEstimationDays = [];

            this.zip = this.dataset.zip;
            this.country = this.dataset.country;
            this.province = this.dataset.province;
            this.label = this.dataset.label;
            this.appendText = this.dataset.appendText;
            this.preorderDate = this.dataset.preorderDate;

            this.fetchUrl = `${window.routes?.cart_url}/shipping_rates.json`;
            const rawLocale = window.Shopify?.locale || "en";
            const localeParts = rawLocale.split("-");
            const language = (localeParts[0] || "en").toLowerCase();
            const regionFromLocale = (localeParts[1] || "").toUpperCase();
            const region = (window.Shopify?.country || regionFromLocale || "US").toUpperCase();
            this.localeCountry = `${language}-${region}`;

            this.dataset.estimationDays?.split("-")?.forEach(day => {
                const dayN = parseInt(day.trim());

                if (!isNaN(dayN) && dayN >= 0) {
                    configEstimationDays.push(dayN);
                }
            });

            if (configEstimationDays.length > 0) {
                this.updateDeliveryEstimate(configEstimationDays);
            } else if (this.zip && this.country && this.province) {
                this.estimateDelivery();
            }
        }

        estimateDelivery () {
            const params = new URLSearchParams();

            params.append("shipping_address[zip]", this.zip);
            params.append("shipping_address[country]", this.country);
            params.append("shipping_address[province]", this.province);

            fetch(`${this.fetchUrl}?${params.toString()}`, { method: "GET" })
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Error:", response.status);
                    }

                    return response.json();
                })
                .then(data => {
                    const shippingRates = data.shipping_rates || [];
                    const deliveryDays = shippingRates[0]?.delivery_days;

                    this.updateDeliveryEstimate(deliveryDays);
                })
                .catch(error => {
                    console.error("Error fetching delivery estimate", error);
                });
        }

        updateDeliveryEstimate (days = []) {
            let textOut = days.map(day => {
                let startDate;

                if (this.preorderDate) {
                    const dateParts = this.preorderDate.split('/');
                    if (dateParts.length === 3) {
                        const day = parseInt(dateParts[0], 10);
                        const month = parseInt(dateParts[1], 10) - 1;
                        const year = parseInt(dateParts[2], 10);

                        startDate = new Date(year, month, day);

                        if (isNaN(startDate.getTime())) {
                            startDate = new Date();
                        }
                    } else {
                        startDate = new Date();
                    }
                } else {
                    startDate = new Date();
                }

                const deliveryDate = new Date(startDate);

                let remainingBusinessDays = day;
                while (remainingBusinessDays > 0) {
                    deliveryDate.setDate(deliveryDate.getDate() + 1);
                    const weekDay = deliveryDate.getDay();
                    if (weekDay !== 0 && weekDay !== 6) {
                        remainingBusinessDays -= 1;
                    }
                }

                // If the computed day lands on weekend (e.g. day = 0), shift to next business day.
                while (deliveryDate.getDay() === 0 || deliveryDate.getDay() === 6) {
                    deliveryDate.setDate(deliveryDate.getDate() + 1);
                }

                try {
                    return new Intl.DateTimeFormat(this.localeCountry, {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    }).format(deliveryDate);
                } catch (e) {
                    return new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    }).format(deliveryDate);
                }
            }).join(" - ");

            if (this.appendText) {
                textOut += ` ${this.appendText}`;
            }

            this.textContent = textOut;
        }
    }

    function setupCustomElements() {
        if (!customElements.get("vo-dark-toggle")) {
            customElements.define("vo-dark-toggle", VoDarkToggle);
        }
        if (!customElements.get("vo-tabs")) {
            customElements.define("vo-tabs", VoTabs);
        }
        if (!customElements.get('vo-dialog')) {
            customElements.define("vo-dialog", VoDialog);
        }
        if (!customElements.get("vo-modal-trigger")) {
            customElements.define("vo-modal-trigger", VoModalTrigger);
        }
        if (!customElements.get("vo-modal-closer")) {
            customElements.define("vo-modal-closer", VoModalCloser);
        }
        if (!customElements.get('vo-text-field')) {
            customElements.define("vo-text-field", VoTextField);
        }
        if (!customElements.get('vo-quantity-input')) {
            customElements.define("vo-quantity-input", VoQuantitySelector);
        }
        if (!customElements.get("vo-rangeslider")) {
            customElements.define("vo-rangeslider", VoRangeSlider);
        }
        if (!customElements.get("vo-delivery-estimator")) {
            customElements.define("vo-delivery-estimator", VoDeliveryEstimator);
        }
    }

    function setupListeners () {
        document.querySelectorAll(".js-vo-modal").forEach((modal) => {
            modal.addEventListener("click", (event) => {
                const isBackdrop = event.target === modal;
                const backdropClickClose = modal.getAttribute("data-backdrop-close") === "true";
        
                if (isBackdrop && backdropClickClose && typeof modal.close === "function") {
                    modal.close();
                }
            });
        });
        
        document.querySelectorAll(".js-vo-modal-close").forEach((btn) => {
            btn.addEventListener("click", () => btn.closest("dialog")?.close());
        });

        document.querySelectorAll(".js-vo-modal-btn").forEach((btn) => {
            btn.addEventListener("click", (event) => {
                event.stopPropagation();
                event.preventDefault();
                cachePendingSubscribePromo(btn);
                const modalId = btn.getAttribute("data-modal-id");
                const target = modalId ? document.getElementById(modalId) : null;

                if (target && !target.open && typeof target.showModal === "function") {
                    target.showModal();
                }
            });
        });

        document.querySelectorAll(".js-vo-multi-modal-btn").forEach((btn) => {
            btn.addEventListener("click", (event) => {
                event.stopPropagation();
                event.preventDefault();
                cachePendingSubscribePromo(btn);
                const modalIds = btn.getAttribute("data-multi-modal-id")?.split("|").map(id => id.trim()) || [];
                modalIds.forEach((id) => {
                    const target = id ? document.getElementById(id) : null;
                    if (!target) return;

                    if (target && !target.open && typeof target.showModal === "function") {
                        target.showModal();
                    }
                });
            });
        });

        const cachePendingSubscribePromo = (btn) => {
            const modalId = btn.getAttribute("data-modal-id");
            if (modalId !== "newsletter-dialog") return;

            const promoEnabled = btn.getAttribute("data-subscribe-promocode-enabled") === "true";
            const promoValue = (btn.getAttribute("data-subscribe-promocode-value") || "").trim();

            if (!promoEnabled || promoValue === "") {
                clearPendingSubscribePromo();
                return;
            }

            try {
                sessionStorage.setItem(PENDING_PROMO_CODE_KEY, promoValue);
                sessionStorage.setItem(PENDING_PROMO_PATH_KEY, normalizePath(window.location.pathname));
                sessionStorage.setItem(PENDING_PROMO_TS_KEY, String(Date.now()));
            } catch (error) {
                // no-op: sessionStorage can be unavailable (privacy mode)
            }
        };
    }

    setupCustomElements()
    setupListeners()
}

voComponents();
